import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkOrdersActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#b)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M18.899 8.64a1.27 1.27 0 0 0-1.016-.515h-1.008v-1.25a1.25 1.25 0 0 0-1.25-1.25h-5.414L8.039 4a1.22 1.22 0 0 0-.75-.25H3.125A1.25 1.25 0 0 0 1.875 5v11.25a.617.617 0 0 0 .625.625h13.75a.625.625 0 0 0 .594-.43l2.226-6.672a1.27 1.27 0 0 0-.172-1.132M7.288 5l2.172 1.625c.215.164.48.252.75.25h5.414v1.25H5.453a1.25 1.25 0 0 0-1.187.852l-1.141 3.421V5z"
			})
		}), /* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M2.5 16V5a.625.625 0 0 1 .625-.625h4.164c.135 0 .267.044.375.125l2.172 1.625c.108.08.24.124.375.125h5.414a.625.625 0 0 1 .625.625V8.75"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h20v20H0z"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "b",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h20v20H0z"
		})
	})] })]
});
export default SvgWorkOrdersActive;
